export default {
    activeLoading: (state, payload) => {
        state.stateLoading = payload
    },
    toggleSidebar: (state, payload) => {
        state.sidebarState = payload
    },
    changeSidebarState: (state, payload) => {
        state.sidebarState = payload
    },

    StoreNumber: (state, payload) => {
        state.user_number = payload
    },
    StoreEmail: (state, payload) => {
        state.user_email = payload
    },
    StoreGuestNumber: (state, payload) => {
        state.guest_number = payload
    },

    StoreUserData: (state, payload) => {
        state.userData = payload
    },
    StoreAuthStatus: (state, payload) => {
        state.authenticated = payload
    },
    notificationCount: (state, payload) => {
        state.state_notifications_count = payload
    },
    StoreNotifications: (state, payload) => {
        state.state_notifications = payload
    },
    StoreSetting: (state, payload) => {
        state.state_setting = payload
    },
    StoreBankAccounts: (state, payload) => {
        state.state_bank_accounts = payload
    },
    StoreWallets: (state, payload) => {
        state.state_wallets = payload
    },
    StorePrice: (state, payload) => {
        state.state_prices = payload
    },

    StoreRealTimePrices: (state, payload) => {
        state.realTime_prices = payload
    },
    UserLogout: (state) => {
        state.authenticated = false
        state.userData = {
            user_detail: {}
        };
    },
}